import * as actionTypes from "./actionTypes";
import * as types from "./types";


// Fetch Task List for extractor triggers
export const fetchTaskListReq = (params: types.ITaskListParams): types.FetchTaskListReq => ({
    type: actionTypes.FETCH_TASK_LIST_REQUEST,
    params,
});

export const fetchTaskListSuccess = (
    payload: types.FetchTaskListSuccessPayload
): types.FetchTaskListSuccess => ({
    type: actionTypes.FETCH_TASK_LIST_SUCCESS,
    payload,
});

export const fetchTaskListFailure = (
    payload: types.FetchTaskListFailurePayload
): types.FetchTaskListFailure => ({
    type: actionTypes.FETCH_TASK_LIST_FAILURE,
    payload,
});

// Fetch Task List for loader triggers
export const fetchLoaderListReq = (params: types.ILoaderListParams): types.FetchLoaderListReq => ({
    type: actionTypes.FETCH_LOADER_LIST_REQUEST,
    params,
});

export const fetchLoaderListSuccess = (
    payload: types.FetchLoaderListSuccessPayload
): types.FetchLoaderListSuccess => ({
    type: actionTypes.FETCH_LOADER_LIST_SUCCESS,
    payload,
});

export const fetchLoaderListFailure = (
    payload: types.FetchLoaderListFailurePayload
): types.FetchLoaderListFailure => ({
    type: actionTypes.FETCH_LOADER_LIST_FAILURE,
    payload,
});

// Event Task List 
export const fetchEventTaskListReq = (params: types.IEventTaskListParams): types.FetchEventTaskListReq => ({
    type: actionTypes.FETCH_EVENT_TASK_LIST_REQUEST,
    params,
});

export const fetchEventTaskListSuccess = (
    payload: types.FetchEventTaskListSuccessPayload
): types.FetchEventTaskListSuccess => ({
    type: actionTypes.FETCH_EVENT_TASK_LIST_SUCCESS,
    payload,
});

export const fetchEventTaskListFailure = (
    payload: types.FetchEventTaskListFailurePayload
): types.FetchEventTaskListFailure => ({
    type: actionTypes.FETCH_EVENT_TASK_LIST_FAILURE,
    payload,
});

// Event List actions
export const fetchEventListReq = (params: types.IEventListParams): types.FetchEventListReq => ({
    type: actionTypes.FETCH_EVENT_LIST_REQUEST,
    params,
});

export const fetchEventListSuccess = (
    payload: types.FetchEventListSuccessPayload
): types.FetchEventListSuccess => ({
    type: actionTypes.FETCH_EVENT_LIST_SUCCESS,
    payload,
});

export const fetchEventListFailure = (
    payload: types.FetchEventListFailurePayload
): types.FetchEventListFailure => ({
    type: actionTypes.FETCH_EVENT_LIST_FAILURE,
    payload,
});

// Inbound (Webhooks) actions
export const fetchInboundListReq = (params: types.IInboundListParams): types.FetchInboundListReq => ({
    type: actionTypes.FETCH_INBOUND_LIST_REQUEST,
    params,
});

export const fetchInboundListSuccess = (
    payload: types.FetchInboundListSuccessPayload
): types.FetchInboundListSuccess => ({
    type: actionTypes.FETCH_INBOUND_LIST_SUCCESS,
    payload,
});

export const fetchInboundListFailure = (
    payload: types.FetchInboundListFailurePayload
): types.FetchInboundListFailure => ({
    type: actionTypes.FETCH_INBOUND_LIST_FAILURE,
    payload,
});

// Inbound (Webhooks) actions
export const fetchOutboundListReq = (params: types.IOutboundListParams): types.FetchOutboundListReq => ({
    type: actionTypes.FETCH_OUTBOUND_LIST_REQUEST,
    params,
});

export const fetchOutboundListSuccess = (
    payload: types.FetchOutboundListSuccessPayload
): types.FetchOutboundListSuccess => ({
    type: actionTypes.FETCH_OUTBOUND_LIST_SUCCESS,
    payload,
});

export const fetchOutboundListFailure = (
    payload: types.FetchOutboundListFailurePayload
): types.FetchOutboundListFailure => ({
    type: actionTypes.FETCH_OUTBOUND_LIST_FAILURE,
    payload,
});

// Create a task
export const postTaskRequest = (payload: types.IPostTaskParams): types.PostTaskRequest => ({
    type: actionTypes.POST_TASK_REQUEST,
    payload
});

export const postTaskSuccess = (payload: types.IPostTaskSuccessPayload): types.PostTaskSuccess => ({
    type: actionTypes.POST_TASK_SUCCESS,
    payload
});

export const postTaskFailure = (payload: types.IPostTaskFailurePayload): types.PostTaskFailure => ({
    type: actionTypes.POST_TASK_FAILURE,
    payload
});

// Task Connection
export const fetchTaskConnectionReq = (params: types.ITaskConnectionParams): types.FetchTaskConnectionReq => ({
    type: actionTypes.FETCH_TASK_CONNECTION_REQUEST,
    params,
});

export const fetchTaskConnectionSuccess = (
    payload: types.FetchTaskConnectionSuccessPayload
): types.FetchTaskConnectionSuccess => ({
    type: actionTypes.FETCH_TASK_CONNECTION_SUCCESS,
    payload,
});

export const fetchTaskConnectionReset = (): types.FetchTaskConnectionReset => ({
    type: actionTypes.FETCH_TASK_CONNECTION_RESET,
});

export const fetchTaskConnectionFailure = (
    payload: types.FetchTaskConnectionFailurePayload
): types.FetchTaskConnectionFailure => ({
    type: actionTypes.FETCH_TASK_CONNECTION_FAILURE,
    payload,
});

// Create a task connection
export const postTaskConnectionRequest = (payload: types.newTaskConnection): types.PostTaskConnectionRequest => ({
    type: actionTypes.POST_TASK_CONNECTION_REQUEST,
    payload
});

export const postTaskConnectionSuccess = (payload: types.IPostTaskConnectionSuccessPayload): types.PostTaskConnectionSuccess => ({
    type: actionTypes.POST_TASK_CONNECTION_SUCCESS,
    payload
});

export const postTaskConnectionReset = (): types.PostTaskConnectionReset => ({
    type: actionTypes.POST_TASK_CONNECTION_RESET,
});

export const postTaskConnectionFailure = (payload: types.IPostTaskConnectionFailurePayload): types.PostTaskConnectionFailure => ({
    type: actionTypes.POST_TASK_CONNECTION_FAILURE,
    payload
});

// PUT task

export const putTaskRequest = (
    taskId: string,
    payload: types.IPutTaskParams
): types.PutTaskRequest => ({
    type: actionTypes.PUT_TASK_REQUEST,
    taskId,
    payload
});

export const putTaskSuccess = (
    payload: types.IPutTaskSuccessPayload
): types.PutTaskSuccess => ({
    type: actionTypes.PUT_TASK_SUCCESS,
    payload,
});

export const putTaskReset = (
    ): types.PutTaskReset => ({
        type: actionTypes.PUT_TASK_RESET,
    });

export const putTaskFailure = (
    payload: types.IPutTaskFailurePayload
): types.PutTaskFailure => ({
    type: actionTypes.PUT_TASK_FAILURE,
    payload,
});